import MagazzinoArticoliListPage from "./pages/MagazzinoArticoliListPage.vue";
import MagazzinoArticoliEditPage from "./pages/MagazzinoArticoliEditPage.vue";
import MagazzinoArticoliViewPage from "./pages/MagazzinoArticoliViewPage.vue";
// import ConfigurazioniMagazzinoArticoliListPage from "./pages/ConfigurazioniMagazzinoArticoliListPage.vue";
import ConfigurazioniMagazzinoArticoliTipoListPage from "./pages/ConfigurazioniMagazzinoArticoliTipoListPage.vue";
import ConfigurazioniMagazzinoArticoliUmListPage from "./pages/ConfigurazioniMagazzinoArticoliUmListPage.vue";
import ConfigurazioniMagazzinoArticoliCategoriaListPage from "./pages/ConfigurazioniMagazzinoArticoliCategoriaListPage.vue";
import ConfigurazioniMagazzinoArticoliMarcaListPage from "./pages/ConfigurazioniMagazzinoArticoliMarcaListPage.vue";
import ConfigurazioniMagazzinoArticoliMultiploListPage from "./pages/ConfigurazioniMagazzinoArticoliMultiploListPage.vue";
import ConfigurazioniMagazzinoArticoliImballoListPage from "./pages/ConfigurazioniMagazzinoArticoliImballoListPage.vue";
import ConfigurazioniMagazzinoFornitoriListPage from "./pages/ConfigurazioniMagazzinoFornitoriListPage.vue";
import ConfigurazioniMagazzinoTipoDocumentoListPage from "./pages/ConfigurazioniMagazzinoTipoDocumentoListPage.vue";
import ConfigurazioneMagazzinoMagazziniListPage from "./pages/ConfigurazioneMagazzinoMagazziniListPage.vue";
export default {
	MagazzinoArticoliListPage,
	MagazzinoArticoliEditPage,
	MagazzinoArticoliViewPage,
	// ConfigurazioniMagazzinoArticoliListPage,
	ConfigurazioniMagazzinoArticoliTipoListPage,
	ConfigurazioniMagazzinoArticoliUmListPage,
	ConfigurazioniMagazzinoArticoliCategoriaListPage,
	ConfigurazioniMagazzinoArticoliMarcaListPage,
	ConfigurazioniMagazzinoArticoliMultiploListPage,
	ConfigurazioniMagazzinoArticoliImballoListPage,
	ConfigurazioniMagazzinoFornitoriListPage,
	ConfigurazioniMagazzinoTipoDocumentoListPage,ConfigurazioneMagazzinoMagazziniListPage
};
